<template>
  <b-modal
    :id="modalId"
    hide-footer
    hide-header
    centered
    content-class="pendency-modal"
  >
    <div class="pendency-header">
      <h3>{{ title }}</h3>
    </div>
    <div class="pendency-divider"></div>
    <div class="pendency-body">
      <b-form-textarea
        v-model="pendencyValue"
        rows="3"
        max-rows="6"
        placeholder="Descreva a pendência..."
      ></b-form-textarea>
    </div>
    <div class="pendency-footer">
      <div v-if="loading" class="spinner-container">
        <b-spinner variant="success" label="Carregando..."></b-spinner>
      </div>
      <b-button v-else @click="save">{{ buttonText }}</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PendencyEditModal",
  props: {
    modalId: {
      type: String,
      default: "modal-evidence",
    },
    title: {
      type: String,
      default: "Pendência",
    },
    value: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "Registrar Pendência",
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pendencyValue: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.pendencyValue = newVal;
    },
  },
  methods: {
    save() {
      this.$emit("save", this.pendencyValue);
    },
    close() {
      this.$bvModal.hide(this.modalId);
      this.$emit("close");
    },
    show() {
      this.$bvModal.show(this.modalId);
    },
  },
};
</script>

<style lang="scss" scoped>
.pendency-modal {
  border-radius: 8px;
  overflow: hidden;
}

.pendency-header {
  padding: 15px 20px 0;

  h3 {
    color: #36b67d;
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    margin: 0;
  }
}

.pendency-divider {
  height: 1px;
  background-color: #e6e6e6;
  margin: 15px 0;
  position: relative;

  &:after,
  &:before {
    content: none !important;
  }
}

.pendency-body {
  padding: 0 20px;

  textarea {
    min-height: 100px;
    border-radius: 4px;
    border: 1px solid #e6e6e6;
    width: 100%;
    padding: 15px;
    font-size: 16px;
    line-height: 1.5;
    color: #4f4f4f;
    resize: vertical;
  }
}

.pendency-footer {
  padding: 15px 20px;
  display: flex;
  justify-content: flex-end;

  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 38px;
  }

  button {
    background-color: #68c5b7;
    border-color: #68c5b7;
    color: white;
    font-weight: 500;
    padding: 8px 20px;
    border-radius: 4px;

    &:hover {
      background-color: darken(#68c5b7, 7%);
      border-color: darken(#68c5b7, 7%);
    }
  }
}
</style>
